import { render } from "./AppButton.vue?vue&type=template&id=247c0905&scoped=true&bindings={}"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=247c0905&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-247c0905"

export default script